import { IReadOnlyResourceManager } from "../../ResourceManager/ResourceManager";
import { SlotGameType1_2_2Screen } from "../SlotGameType1_2_2Screen";

// namespace SlotGames2
// {
	export class RainbowTreasure2_2Screen extends SlotGameType1_2_2Screen
	{
   
		// public PrepareFont(resourceManager: ResourceManager)
		// {
		//  resourceManager.Add(new FontResource(this.basepath + "resources/AXR Neverland Shadow.ttf",this.resid.ScopedResourceName(["BigSymbolFreegames2-font"])));
		// }
	//	protected freegameBonusFactory: FreegameBonusFactory2 = new RainbowTreasureFreegame2BonusFactory();

	protected override PaytableLoaded(resourceManager: IReadOnlyResourceManager): void 
	{
	}
}

// }